import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

import JsonDisplay from '../utils/JsonDisplay';

/**
 * Renders user data messages with modal JSON content
 * @param {Object} props - Component props
 * @param {Object} props.message - User data message object
 */
const UserDataMessage = ({ message }) => {
  const [showModal, setShowModal] = useState(false);

  /**
   * Opens the modal
   */
  const handleOpen = () => {
    setShowModal(true);
  };

  /**
   * Closes the modal
   */
  const handleClose = () => {
    setShowModal(false);
  };

  /**
   * Splits content into instruction and JSON parts
   * @param {string} content - Message content
   * @returns {Object} Separated instruction and JSON parts
   */
  const parseContent = (content) => {
    const jsonStart = content.indexOf('{');
    if (jsonStart === -1) return { instruction: content, jsonPart: null };

    return {
      instruction: content.substring(0, jsonStart).trim(),
      jsonPart: content.substring(jsonStart),
    };
  };

  const { instruction, jsonPart } = parseContent(message.content);

  return (
    <div className='mb-2'>
      {/* JSON data button */}
      <div
        className='bg-white rounded cursor-pointer d-inline-block'
        onClick={handleOpen}
        style={{ padding: 4, border: '1px solid #ccc' }}
      >
        <div
          className='d-flex align-items-center justify-content-center rounded bg-light'
          style={{ height: 50, width: 50 }}
        >
          <span className='fw-bold fs--1'>DATA</span>
        </div>
      </div>

      {/* Modal for JSON content */}
      <Modal show={showModal} onHide={handleClose} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>Data Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='overflow-auto' style={{ maxHeight: '500px' }}>
            {instruction && <div className='mb-3 text-dark'>{instruction}</div>}
            {jsonPart && <JsonDisplay jsonString={jsonPart} />}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='outline-secondary'
            size='sm'
            style={{ fontSize: '0.75rem', minWidth: '75px' }}
            onClick={handleClose}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UserDataMessage;
